if (!customElements.get('free-shipping-progress')) {

// Change 5: SVG checkmark constant — matches icon-checkmark.svg exactly
const CHECKMARK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';

class FreeShippingProgress extends HTMLElement {
  constructor() {
    super();
    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.celebration = this.dataset.celebration || 'subtle';
    this.placement = this.dataset.placement || 'drawer';
    this.unsubscribe = null;
    this.wasUnlocked = this.classList.contains('is-unlocked');
  }

  connectedCallback() {
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || !event.cartData) return;
      this.update(event.cartData);
    });
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  update(cart) {
    const subtotal = cart.items_subtotal_price || 0;
    const itemCount = cart.item_count || 0;
    const unlocked = this.threshold > 0 && subtotal >= this.threshold;
    const remaining = Math.max(0, this.threshold - subtotal);
    const percent = this.threshold > 0
      ? Math.min(100, (subtotal / this.threshold) * 100)
      : 0;
    const currency = cart.currency || 'USD';

    if (this.placement !== 'announcement') {
      this.classList.toggle('is-hidden', itemCount === 0);
    } else {
      this.classList.remove('is-hidden');
    }

    const fill = this.querySelector('[data-fill]');
    if (fill) fill.style.width = `${percent}%`;

    const track = this.querySelector('[role="progressbar"]');
    if (track) track.setAttribute('aria-valuenow', Math.round(percent));

    const label = this.querySelector('[data-label]');
    if (label) {
      if (unlocked) {
        // Change 5: use SVG constant instead of ✓ character
        label.innerHTML = `<span class="free-shipping-progress__icon" aria-hidden="true">${CHECKMARK_SVG}</span> Free shipping unlocked`;
      } else if (this.placement === 'announcement' && itemCount === 0) {
        label.textContent = `Free shipping on orders ${this.formatMoney(this.threshold, currency)}+`;
      } else if (this.placement === 'announcement') {
        // Change 6: announcement keeps short copy without action prompt
        label.innerHTML = `You're <span data-remaining>${this.formatMoney(remaining, currency)}</span> from free shipping`;
      } else {
        // Change 6: drawer + cart get action prompt
        label.innerHTML = `You're <span data-remaining>${this.formatMoney(remaining, currency)}</span> from free shipping — add more to unlock`;
      }
    }

    this.classList.toggle('is-unlocked', unlocked);
    if (unlocked && !this.wasUnlocked) {
      this.celebrate();
    }
    this.wasUnlocked = unlocked;
  }

  celebrate() {
    if (this.celebration === 'animated') {
      this.spawnConfetti();
    } else {
      this.classList.add('is-celebrating-subtle');
      setTimeout(() => this.classList.remove('is-celebrating-subtle'), 1200);
    }
  }

  spawnConfetti() {
    const burst = document.createElement('div');
    burst.className = 'free-shipping-progress__confetti';
    burst.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 8; i++) {
      const dot = document.createElement('span');
      dot.style.setProperty('--i', i);
      burst.appendChild(dot);
    }
    this.appendChild(burst);
    setTimeout(() => burst.remove(), 1300);
  }

  formatMoney(cents, currency) {
    const value = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      }).format(value);
    } catch (_e) {
      return `$${value.toFixed(2)}`;
    }
  }
}

customElements.define('free-shipping-progress', FreeShippingProgress);
}
